import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import SV from 'server-vars';
import CirclePlus from 'dibs-icons/exports/CirclePlus';

import styles from './NewProjectTile.scss';

type Props = {
    createDesignProject: () => void;
    isClient: boolean;
};

export const NewProjectTile: FC<Props> = ({ createDesignProject, isClient }) => {
    if (isClient && !SV.get('settings.isDesktop')) {
        return null;
    }

    return (
        <div
            className={styles.container}
            onClick={createDesignProject}
            data-tn="create-new-design-project"
        >
            <div className={styles.innerContainer}>
                <CirclePlus className={styles.addProjectIcon} />
                <div className={styles.addProject}>
                    <FormattedMessage
                        id="abt.designProfile.NewProjectTile.addProjectCta"
                        defaultMessage="Add a new project"
                    />
                </div>
            </div>
        </div>
    );
};
